export default __webpack_public_path__ + "static/media/icn-green-chck.aed17a86.svg";